import Axios from 'axios'
import config from "@/utils/config"
const base_url=config.context;
// const base_url="/v1"
const baseUrl=window.appConfig.APP_URL;
import { getStorage } from "@/utils/localStorage";
export function login() {
  return Axios({
    url: base_url+'/login/toLogin',
    method: "POST",
  })
}
//获取所有用户
export function getAllUser() {
  return Axios({
    url: base_url+'/businessManagement/userManagement/getAllUser',
    method: "POST",
  })
}

export function loginTxzk() {
  const companyInfo =JSON.parse(getStorage('companyInfo')||"{}");//TODO:获取租户公司信息
  return Axios({
    url: companyInfo.serviceIp+'/auth/login',
    method: "POST",
    data: {"username":companyInfo.serviceUserName,"code":companyInfo.serviceCode}
  })
}
//获取所有用户
export function getAllWorker() {
  const companyInfo =JSON.parse(getStorage('companyInfo')||"{}");//TODO:获取租户公司信息
  return Axios({
    url: companyInfo.serviceIp+'/api/sis/data/snapshot',
    method: "GET",
    headers:{
      Authorization:getStorage("txzkToken")
    }
  })
}

/**
 * TODO:定位卡查询
 * @returns {AxiosPromise}
 */
export function getTxzkCards() {
  const companyInfo =JSON.parse(getStorage('companyInfo')||"{}");//TODO:获取租户公司信息
  return Axios({
    url: companyInfo.serviceIp+'/api/eam/card/data',
    method: "GET",
    headers:{
      Authorization:getStorage("txzkToken")
    }
  })
}

/**
 * TODO:获取报警列表数据
 * @param status,0=未读,1=已读，2=关闭
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise}
 */
export function getTXZKWarnData(status=0,pageNum=1,pageSize=20) {
  const companyInfo =JSON.parse(getStorage('companyInfo')||"{}");//TODO:获取租户公司信息
  return Axios({
    url: companyInfo.serviceIp+'/api/sis/warnData/list?pageNum='+pageNum+'&pageSize='+pageSize+'&warnType=sos&status='+status,
    method: "GET",
    headers:{
      Authorization:getStorage("txzkToken")
    }
  })
}

/**
 * TODO:获取报警列表数据
 * @param status,0=未读,1=已读，2=关闭
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise}
 */
export function doTXZKWarn(remark,cardId=0,createTime) {
  const companyInfo =JSON.parse(getStorage('companyInfo')||"{}");//TODO:获取租户公司信息
  return Axios({
    url: companyInfo.serviceIp+'/api/sis/warnData/process',
    method: "PUT",
    headers:{
      Authorization:getStorage("txzkToken")
    },
    data: {
      warnType:"sos",
      cardId:cardId,
      areaId:null,
      createTime:createTime,
      remark:remark
    }
  })
}

/**
 *  TODO:获取作业人员历史轨迹
 * @param entityIds，实体ID数组
 * @param beginCreateTime，查询起始时间
 * @param endCreateTime，查询结束时间
 * @returns {AxiosPromise}
 */
export function getTXZKWorkerHistory(params) {
  const companyInfo =JSON.parse(getStorage('companyInfo')||"{}");//TODO:获取租户公司信息
  return Axios({
    url: companyInfo.serviceIp+'/api/sis/locationData/history?pageNum=1&pageSize=10&entityIds='+params.entityId+
        '&params%5BbeginCreateTime%5D='+params.time[0]+'&params%5BendCreateTime%5D='+params.time[1],
    method: "GET",
    headers:{
      Authorization:getStorage("txzkToken")
    }
  })
}

/**
 * 获取当前登录用户信息
 * @returns {AxiosPromise}
 */
export function getUserInfo() {
  return Axios({
    url: baseUrl+'/user/getUserInfo',
    method: "GET"
  })
}

/**
 * 获取用户所有模型列表
 * @returns {AxiosPromise}
 */
export function getModelList() {
  return Axios({
    url: baseUrl+'/model/list_all',
    method: "GET"
  })
}

/**
 * 获取所有建筑物
 * @returns {AxiosPromise}
 */
export function getBuildingList() {
  return Axios({
    url: baseUrl+'/building/list_all',
    method: "GET"
  })
}

/**
 * 获取所有监控
 * @returns {AxiosPromise}
 */
export function getCameraList() {
  return Axios({
    url: baseUrl+'/licensePlateCamera/list_all',
    method: "GET"
  })
}

/**
 * 获取所有重大危险源
 * @returns {AxiosPromise}
 */
export function getDangerList() {
  return Axios({
    url: baseUrl+'/dsMajorHazards/list_all',
    method: "GET"
  })
}

/**
 * 获取所有作业人员
 * @returns {AxiosPromise}
 */
export function getWorkerList() {
  return Axios({
    url: baseUrl+'/employee/getAll',
    method: "GET"
  })
}

/**
 * 获取所有车辆
 * @returns {AxiosPromise}
 */
export function getVehicleList() {
  return Axios({
    url: baseUrl+'/vehicleInformation/list_all',
    method: "GET"
  })
}


/**
 * 获取所有设备装置
 * @returns {AxiosPromise}
 */
export function getDeviceList() {
  return Axios({
    url: baseUrl+'/equipment/list_all',
    method: "GET"
  })
}

/**
 * 获取所有有害物质
 * @returns {AxiosPromise}
 */
export function getHarmList() {
  return Axios({
    url: baseUrl+'/harmfulmessage/list_all',
    method: "GET"
  })
}

/**
 * 获取所有仓库物资
 */
export function getStoreList() {
  return Axios({
    url: baseUrl+'/materials/list_all',
    method: "POST"
  })
}

/**
 * 重大危险源列表
 * @param params
 * @returns {*}
 */
export function hazardInstallationsList(params) {
  return Axios({
    url: baseUrl+'/dsMajorHazards/list_all',
    method: "GET",
    params
  });
}


/**
 * 获取风险点 所有风险区域
 * @param params
 * @returns {*}
 */
export function getRiskPointList(params) {
  return Axios({
    url: baseUrl+'/riskclassification/list_all',
    method: "GET",
    params
  });
}

/**
 * 区域风险管理
 * @param params
 * @returns {*}
 */
export function getFxListNew(params) {
  return Axios({
    url: baseUrl+'/dangerinfo/findAreaRisk',
    method: "GET",
    params
  });
}

/**
 * 获取巡检任务
 * @param params
 * @returns {AxiosPromise}
 */
export function getTroubleshootTask(params) {
  return Axios({
    url: baseUrl+'/troubleshoottask/list_all',
    method: "POST",
    data:{
      ...params
    }
  });
}


/**
 *
 * @param params
 * @returns {AxiosPromise}
 */
export function getWorkPermitList(params) {
  return Axios({
    url: baseUrl+'/workPermit/list_all',
    method: "POST",
    data:{
      ...params
    }
  });
}

/**
 * 根据url获取数据
 * @param url
 * @returns {AxiosPromise}
 */
export function getByUrl(url) {
  return Axios({
    url: url,
    method: "GET"
  })
}
